module.exports = "/fonts/vendor/material-design-icons-icondist/MaterialIcons-Regular.woff?824b570fb059ee0a44a983ad4ae89cfa";